import { S3Client, PutObjectCommand, GetObjectCommand, DeleteObjectCommand, ListObjectsCommand } from "@aws-sdk/client-s3";

export const s3 = new S3Client({
  endpoint: "https://api.minio.fablia.fr",
  region: 'eu',
  credentials: {
    accessKeyId: "minioadmin",
    secretAccessKey: "91hztzfbojezvgx6",
  },
  forcePathStyle: true,
});

export const uploadFileToAws = async (fileName, file, contentType = null) => {
  const buffer = await file.arrayBuffer();

  const uploadParams = {
    Bucket: 'storia',
    Key: fileName,
    Body: buffer,
  };

  if (contentType) {
    uploadParams.ContentType = contentType;
    if (contentType === 'application/pdf') {
      uploadParams.ContentDisposition = 'inline';
    }
  }

  const data = await s3.send(new PutObjectCommand(uploadParams));
  return data;
};

export const getFileUrl = (fileName) => {
  return `https://api.minio.fablia.fr/storia/${fileName}`;
};


export const getFileObject = async (fileName) => {
  const params = {
    Bucket: 'storia',
    Key: fileName,
  };

  const data = await s3.send(new GetObjectCommand(params));
  return data;
};

export const deleteFile = async (fileName) => {
  const params = {
    Bucket: 'storia',
    Key: fileName,
  };

  const data = await s3.send(new DeleteObjectCommand(params));
  return data;
};

export const listFiles = async (prefix = '') => {
  const params = {
    Bucket: 'storia',
    Prefix: prefix,
  };

  const data = await s3.send(new ListObjectsCommand(params));
  return data;
};

export const listFilesInFolder = async (folderPath) => {
  const params = {
    Bucket: 'storia',
    Prefix: folderPath,
    Delimiter: '/',
  };

  const data = await s3.send(new ListObjectsCommand(params));
  return data;
};

// Helper function to convert Firebase storage URLs to MinIO URLs
export const convertFirebaseUrlToMinIO = (firebaseUrl) => {
  if (!firebaseUrl || !firebaseUrl.includes('firebasestorage.googleapis.com')) {
    return firebaseUrl; // Return as-is if not a Firebase URL
  }

  // Extract the file path from Firebase URL
  // Example: https://firebasestorage.googleapis.com/v0/b/storiagl.appspot.com/o/musics%2FSummer%20Somewhere%20In%20Cuba%20-%20Cumbia%20Deli.mp3?alt=media&token=...
  const matches = firebaseUrl.match(/\/o\/(.+?)(\?alt=media|$)/);
  if (matches && matches[1]) {
    const filePath = decodeURIComponent(matches[1]);
    return getFileUrl(filePath);
  }

  return firebaseUrl; // Return as-is if pattern doesn't match
};